export default class Session {
    set(id, value) {
        if (typeof value === 'object') value = JSON.stringify(value);
        sessionStorage.setItem(id, value);
    }

    get(id) {
        const value = sessionStorage.getItem(id);
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    remove(id) {

        try {
            sessionStorage.removeItem(id);
        } catch (e) {
            return value;
        }
    }
}